var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrangeTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00017 13.6667C5.68162 13.6667 4.39269 13.2757 3.29636 12.5432C2.20004 11.8106 1.34555 10.7694 0.840969 9.55127C0.336385 8.33309 0.204362 6.99265 0.461597 5.69944C0.718832 4.40623 1.35377 3.21835 2.28612 2.286C3.21847 1.35365 4.40636 0.71871 5.69956 0.461475C6.99277 0.20424 8.33321 0.336263 9.55139 0.840847C10.7696 1.34543 11.8108 2.19991 12.5433 3.29624C13.2758 4.39257 13.6668 5.6815 13.6668 7.00004C13.6668 8.76815 12.9645 10.4638 11.7142 11.7141C10.464 12.9643 8.76828 13.6667 7.00017 13.6667ZM7.00017 12.3334C8.055 12.3334 9.08614 12.0206 9.96321 11.4345C10.8403 10.8485 11.5239 10.0156 11.9275 9.04102C12.3312 8.06648 12.4368 6.99413 12.231 5.95956C12.0252 4.925 11.5173 3.97469 10.7714 3.22881C10.0255 2.48293 9.07521 1.97498 8.04065 1.76919C7.00608 1.5634 5.93373 1.66902 4.95919 2.07269C3.98465 2.47635 3.1517 3.15994 2.56566 4.037C1.97963 4.91406 1.66683 5.94521 1.66683 7.00004C1.66683 8.41453 2.22874 9.77108 3.22893 10.7713C4.22912 11.7715 5.58568 12.3334 7.00017 12.3334ZM6.3335 9.00004H7.66683V10.3334H6.3335V9.00004ZM6.3335 3.66671H7.66683V7.66671H6.3335V3.66671Z",
    fill: "#E7750A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTip);
export default __webpack_public_path__ + "static/media/orange-tip.affcab85437eefc474544fafb2f160df.svg";
export { ForwardRef as ReactComponent };